export default {
    menu: { // 登录
        home: 'Home',
        foundApply: 'Account Open',
        foundTikTokBatch: 'TikTok Batch Open',
        account: 'Account',
        accountList: 'Account List',
        accountRecord: 'Account Record',
        accountRecharge: 'Account Recharge',
        accountMonitor: 'Account Monitor',
        check: 'Check',
        checkWallet: 'Check Wallet',
        checkBalance: 'Check Balance',
        checkCreditBalance: 'Check Credit Balance',
        helpCenter: 'Help',
        marketingTool: 'Influencer Marketing Tool',
        crossBorderBrowser: 'Cross-border Browser',
        storeOperationTools: 'TK Store Operation Tool',
        AdvertisementManagement: 'Advertisement Management',
        TikTok: 'TikTok',
        Partner: 'Partner',
        USCloudPhone: 'US Cloud Phone Number',
        AccountOpeningManagement: 'Account Management',
        cooperativePartner: 'Partner',
        subClient: 'Sub-client management',
        subClientList: 'Sub-client list',
        subClientAdvertiserList: 'Sub-client advertisement list',
        subClientCheckWallet: 'Transaction record',
        subClientAccountRecord: 'Sub-client account opening record',
        promotion: 'Promotion',
        agentSubAccount: 'List of Sub-Accounts',
        mediaAuth: 'Media Management',
        advertiserTransaction: 'Advertising Transaction Details',
        advertiserTransfer: 'Advertising Transfer Details',
        checkCreditLimit: 'Credit Change Records',

    }, crumb: {
        home: 'Home',
        foundApply: 'Account Open',
        foundTikTokBatch: 'TikTok Batch Open',
        Account: 'Account',
        AccountList: 'Account List',
        AccountRecord: 'Account Record',
        AccountRecharge: 'Account Recharge',
        AccountMonitor: 'Account Monitor',
        Check: 'Check',
        CheckWallet: 'Wallet',
        CheckBalance: 'Balance',
        CheckCredit: 'Credit',
        CheckConsume: 'Advertising Cost Details',
        CheckLimit: 'Credit Limit Change Details',
    }, header: {
        Settings: 'Settings',
        LogOut: 'LogOut'
    }, home: { // 登录
        AssetOverview: 'Asset Overview',
        wallet: 'Wallet balance',
        AdvertisingAccount: 'Advertising account balance',
        PlatformWallet: 'Platform Wallet',
        creditBalance: 'credit Balance',
        RechargeWallet: 'Recharge Wallet',
        ViewDetails: 'View Details',
        ActiveAccountBalance: 'Active Account Balance',
        FrozenBalance: 'Frozen Balance',
        PlatformGifts: 'Platform Gifts',
        UsedCredit: 'Used Credit',
        CreditLimit: 'Credit Limit',
        AccountOpeningApplication: 'Account Opening Application',
        inReview: 'inReview',
        ToBeModified: 'To BeModified',
        GoAndModifyIt: 'Go And ModifyIt',
        DisableRate: 'Consumption lockdown rate',
        AccountDisableRate: 'Account closure rate',
        PassedInThePast30Days: 'Passed In The Past 30 Days',
        ApplyForAccountOpening: 'Account Opening',
        PopularEntrance: 'Popular Entrance',
        AccountOpeningApplication2: 'Account Opening',
        IntelligentRecharge: 'Intelligent Recharge',
        AccountReconciliationManagement: 'Account Reconciliation Management',
        account: 'account',
        WalletRecharge: 'Wallet recharge',
        RechargeAmount: 'amount',
        EnterAmount: 'Please enter the recharge amount',
        PaymentMethod: 'Payment',
        Cancel: 'Cancel',
        ConfirmRecharge: 'Confirm Recharge',
        Message1: "The USD balance you have recharged to the platform account,",
        Message2: "Excluding amounts already recharged to media platforms",
        Message3: "The total balance of recharging to media platform advertising accounts",
        Message4: "The credit limit balance granted by the platform,",
        Message5: "The calculation pipeline is: total credit limit - used limit",
        Message6: "New features are now available! Check out how to use them in the Help Center",
        Validity: 'Validity',
    }, login: { // 登录
        title: 'login',
        NoAccount: 'No account？',
        register: 'register',
        WelcomeToLogin: 'Welcome to login',
        PleaseEnterYourPhoneNumberOrEmailAddress: 'Please enter your phone number or email address',
        PleaseEnterYourLoginPassword: 'Please enter your login password',
        ForgotPassword: 'Forgot password?',
        VerificationCodeLogin: 'Verification code login',
        logOn: 'log on',
        LoginSuccess: 'Successfully logged in, redirecting...',
        Mail: 'Email',
        Password: 'Password',
        VerificationCode: 'Verification Code',
        MasterAccountLogin: 'Switch Master Account Login',
        SubAccountLogin: 'Switch Sub-Account Login',
    }, register: { // 注册
        title: 'register',
        ExistingAccount: 'Existing account?',
        GoLogIn: 'Go log in',
        WelcomeToRegister: 'Welcome to register',
        PleaseEnterYourPhoneNumber: 'Please enter your phone number (as the preferred login account)',
        PlaInvitationCode: 'Attention: If there is an invitation code, please enter it. No entry is required',
        LoginPassword: 'Attention: Passwords must contain uppercase and lowercase letters as well as numbers (with no limit on the number of characters)',
        InvitationCode: 'Invitation code',
        ObtainVerificationCode: 'Request Verification Code',
        PleaseEnterYourFrequentlyUsedEmail: 'Please enter your frequently used email (as an alternative account, this is not mandatory)',
        PleaseEnterA6_20DigitLoginPassword: 'Please enter a 6-20 digit login password (including uppercase and lowercase letters and numbers)',
        FreeRegistration: 'Free registration',
        IHaveReadAndAmWillingToAccept: 'I have read and am willing to accept',
        TermsOfService: '《Terms of Service》',
        and: 'and',
        PrivacyStatement: '《Privacy Statement》',
        ElMPleaseEnterYourPhoneNumber: 'Please enter your phone number',
        ElMPleaseEnterYourEmailNumber: 'Please enter your email number',
        ElMPleaseEnterTheVerificationCode: 'Please enter the verification code',
        ElMPleaseEnterPassword: 'Please enter password',
        PleaseAgreeToTheServiceAgreement: 'Please agree to the service agreement',
        SuccessfullySentSMSVerificationCode: 'Successfully sent SMS verification code',
        SuccessfullySentEmailVerificationCode: 'Successfully sent email verification code',
        UserAgreement: '《User Agreement》',
        UserAgreementAdvertisingComplianceManagementSystem: '《Advertising compliance management system》',
        ServiceAndInformationCollectionAgreement: '《Service and Information Collection Agreement》'
    }, forget: {// 找回密码
        title: 'forget password',
        NoAccount: 'No Account?',
        register: 'register',
        RetrievePassword: 'Retrieve password',
        PleaseEnterYourPhoneNumber: 'Please Enter Your PhoneNumber',
        PleaseEnterTheMobileVerificationCode: 'PleaseEnterTheMobileVerificationCode',
        SuccessfullySentSMSVerificationCode: 'SuccessfullySentSMSVerificationCode',
        ObtainVerificationCode: 'Request Verification Code',
        ReturnToLogin: 'Return to login',
        VerifyWithEmail: 'Verify with email',
        PleaseEnterYourEmailNumber: 'Please Enter Your Email Number',
        PleaseEnterTheEmailVerificationCode: 'Please Enter The Email Verification Code',
        SuccessfullySentEmailVerificationCode: 'Successfully Sent Email Verification Code',
        VerifyWithMobilePhone: 'Verify with mobile phone',
        Verify: 'Verify',
        NewPassword: 'Please enter a new password',
        AgainNewPassword: 'Please enter the new password again',
        NewPasswordLogin: 'Modification successful, please log in again',
    }, loginSMS: {// 验证码登录
        title: 'login SMS',
        NoAccount: 'No account？',
        register: 'register',
        WelcomeToLogin: 'Welcome to login',
        PleaseEnterYourPhoneNumber: 'Please Enter Your PhoneNumber',
        PleaseEnterTheMobileVerificationCode: 'PleaseEnterTheMobileVerificationCode',
        SuccessfullySentSMSVerificationCode: 'SuccessfullySentSMSVerificationCode',
        ObtainVerificationCode: 'Request Verification Code',
        PleaseEnterYourEmailAddress: 'Please enter your email address',
        PleaseEnterTheEmailVerificationCode: 'Please Enter The Email Verification Code',
        SuccessfullySentEmailVerificationCode: 'Successfully Sent Email Verification Code',
        PasswordLogin: 'Password login',
        EmailVerificationCodeLogin: 'Email verification code login',
        MobileVerificationLogin: 'Mobile verification login',
        logOn: 'logOn',
    }, password: {
        title: 'Change password',
        ChangePassword: 'Change password',
        PleaseEnterANewPassword: 'Please enter a new password of 6-20 characters (including uppercase and lowercase letters and numbers)',
        PleaseEnterANewPassword2: 'Please enter a new password',
        PleaseEnterTheNewPasswordAgain: 'Please enter the new password again',
        ConfirmModifications: 'Confirm',
        ReturnToLogin: 'Return to login',
        ModificationSuccessful: 'Modification successful, please log in again'
    }, foundApply: { // 开户申请
        OfficialAuthorizedServiceProvider: 'Official Authorized Service Provider',
        TikTok: 'Tiktok International Edition is popular on global short video social platforms, and a large number of trendy young users bring higher conversion rate through strong diversion and exposure of short video content.',
        Google: 'The worlds largest search engine company, with nearly 3 billion monthly active users, displays advertisements at the right time when customers search for your products or services.',
        Facebook: 'Paid per click or per thousand views, it runs very fast and is very user-friendly. In addition, advertisers can also quickly understand the running status of different advertisements through reports.',
        ApplyNow: 'Apply Now',
        BatchApply: 'Batch open',
        ComingSoon: 'Coming Soon',
        Kwai: 'Kwai Committed to supporting users in sharing their life experiences and creating value for users and businesses, we believe that communication and interaction between people can bring business opportunities. By building connections with users, we can benefit your brand.',
        TemporarilyClose: 'Temporarily closed'
    }, foundTikTok: { // 开户申请TikTok
        Tip: "Business License Requirements:",
        Tip1: "1. Please provide a clear, watermark-free mainland China or Hong Kong business license. It must be the latest authentic version.",
        Tip2: "2. Ensure that the QR code below the business license is recognizable.",
        Tip3: "3. If the photo of the submitted business license or organization code certificate is not clear or complete, it may result in a mismatch. After verifying it, please submit the account opening application",
        Tip1Sea: "1. Please provide a clear, watermark-free Southeast Asia business license. It must be the latest authentic version.",
        Port: "Port",
        PortTip: "Please select a port",
        PortCnob: "China CNOB",
        PortSea: "Southeast Asia",
        PortAreaMismatch: "The registration country does not match the selected port. China CNOB uses mainland China or Hong Kong. Southeast Asia uses the license country.",
        QualificationType: "Qualification type",
        BusinessLicense: 'Business License',
        BusinessLicenseTip: 'Please upload the attachment of the business license',
        LicenseTip: 'A business license is a document that proves the legality of your company. Please upload PNG, JPG, JPEG files',
        CompanyRegistrationLocation: 'Company registration location',
        CompanyRegistrationLocationTip: 'Please select the company registration location',
        CompanyName: 'Company Name',
        CompanyNameTip: 'Please enter the company name',
        BusinessLicenseNumber: 'Business License Number',
        BusinessLicenseNumberTip: 'Please enter the business license number',
        AccountTimeZone: 'Account Time Zone',
        AccountTimeZoneTip: 'Please select the account time zone',
        PromotionLink: 'Promotion Link',
        PromotionLinkTip: 'Please enter the promotion link',
        PromotionLinkTip2: 'Please enter the correct link format',
        ContactEmail: 'Contact email',
        ContactEmailTip: 'Please enter the contact email',
        ContactEmailTip2: 'Please enter the correct email format',
        BusinessCenterID: 'Business Center ID',
        BusinessCenterIDTip: 'Please enter the Business Center ID',
        Reset: 'Reset',
        Submit: 'Submit',
    }, foundTikTokBatch: {
        Intro: 'Submit many account applications with one qualification. Each account is created one by one. A batch should be 50 to 500 rows. TikTok review time is not part of this submit.',
        PreviewNote: 'This is a frontend preview. Submitting simulates progress on this page and does not create TikTok accounts. The account list opens only when this username is on the admin whitelist.',
        PreviewMissing: 'This preview batch was not found. Submit again.',
        AccessChecking: 'Checking access',
        AccessClosedTitle: 'Batch opening is not enabled',
        AccessClosed: 'This account is not on the batch-opening whitelist. Ask operations to add the username under account review. No application is required after that.',
        AccessError: 'Access could not be confirmed. Try again shortly.',
        AccessRetry: 'Check again',
        Qualification: 'Qualification',
        Accounts: 'Account list',
        AccountName: 'Account name',
        AccountNameTip: 'Names must be unique in the same Business Center',
        DramaName: 'Drama',
        DramaTip: 'One account, one drama. Optional.',
        Paste: 'Paste list',
        PasteTitle: 'Paste account names',
        PasteTip: 'One row per line. You can also write "account name,drama".',
        PastePlaceholder: 'DramaA-001,Drama A\nDramaA-002,Drama A',
        AddRow: 'Add row',
        Clear: 'Clear list',
        Generate: 'Generate by number',
        Prefix: 'Name prefix',
        StartNo: 'Start number',
        GenCount: 'Count',
        Digits: 'Digits',
        Append: 'Add to list',
        Valid: 'Valid',
        Duplicate: 'Duplicate',
        EmptyName: 'Missing name',
        OverLimit: 'More than 500 rows. Split the batch.',
        UnderLimit: 'Add at least 1 account name',
        LimitHint: '50 to 500 rows per batch',
        Submit: 'Submit batch',
        Single: 'Single application',
        Result: 'Batch progress',
        BatchNo: 'Batch no.',
        Pending: 'Pending',
        Processing: 'Processing',
        Success: 'Success',
        Failed: 'Failed',
        Unknown: 'Unknown',
        All: 'All',
        AdvertiserId: 'Ad account ID',
        FailReason: 'Failure reason',
        RetryFailed: 'Retry failed only',
        RetryUnknown: 'Look up unknown',
        Continue: 'Start another batch',
        ViewRecord: 'Account records',
        NoBatchNo: 'No batch number returned',
        Polling: 'Accounts are being created. Stay on this page to watch progress.',
        StillRunning: 'This is taking a while. Refresh later to see the result.',
        Refresh: 'Refresh',
        Total: 'Total',
        Unit: '',
        Filter: 'Filter',
        Remove: 'Remove',
        ConfirmClear: 'Clear the current account list?',
        NameRequired: 'Every row needs a unique account name',
        DramaOptional: 'Drama',
    }, AccountList: {
        Account: 'name',
        RequestID: 'ID',
        RequestIDTip: 'Please enter the Account ID',
        AccountTip: 'Please enter the account name',
        AccountEntity: 'Account opening entity',
        Media: 'Media platform',
        status: 'status',
        AccountID: 'Account Name/Account ID',
        Currency: 'Currency',
        Balance: 'Balance',
        DailyBudget: 'Daily Budget',
        AccountRecharge: 'Account Recharge',
        DeductionTransfer: 'Deduction Transfer',
        BindUnbind: 'Bind/Unbind',
        AccountRenaming: 'Account Renaming',
        Fail: 'Fail',
        Passed: 'Passed',
        InReview: 'In Review',
        Operate: 'Operate',
        Reset: 'Reset',
        Search: 'Search',
        BatchRecharge: 'Batch recharge',
        BatchZeroing: 'Batch zeroing',
        BatchBinding: 'Batch binding/unbinding',
        ViewBC: 'View BC',
        NewName: 'New name',
        NewNameTip: 'Please enter a new account name',
        Cancel: 'Cancel',
        Confirm: 'Confirm',
        ConfirmModification: 'Confirm modification',
        RechargeAmount: 'Recharge amount',
        RechargeAmountTip: 'Please enter the recharge amount',
        DailyBudgetTip: 'Please enter daily budget',
        ConfirmRecharge: 'Confirm recharge',
        ConfirmClear: 'Confirm Clear',
        AddAccount: 'Add Account',
        BCID: 'BCID',
        EnterBCID: 'Please enter BCID',
        SelectBCID: 'Please select BC ID',
        Email: 'Email',
        EnterEmail: 'Please enter email',
        EnterEmail2: 'Please enter the correct email address',
        SelectEmail: 'Please select email',
        Permission: 'Permission',
        SelectPermission: 'Please select permission',
        AccountSearch: 'Please enter your account name to search and add',
        Select: 'Select',
        Transfer: 'Account reduction transfer request',
        AccountBalance: 'Account balance',
        EstimatedAeductibleAmount: 'Estimated deductible amount',
        TransferID: 'Transfer out account name/ID',
        Type: 'Type',
        TransferAccount: 'Transfer Account',
        TransferAmount: 'Deduction',
        TransferMoney: 'Transfer Money',
        EnterTransferAmount: 'Please enter the transfer amount',
        IsOut: 'Is it all transferred out?',
        Clear: 'Clear to Zero',
        TransferredAccount: 'Transferred to account',
        SelectTransferAccount: 'Please select transfer account',
        BindBC: 'Bind BC',
        UnbindBC: 'Unbind BC',
        BindEmail: 'Bind email',
        UnbindEmail: 'Unbind email',
        EnableMonitoring: 'Enable monitoring',
        AddMonitoring: 'Add monitoring',
        Edit: 'Edit',
        Duration: 'Account opening duration (days)',
        AccountOpeningTime: 'Account opening time',
        banTime: 'Account sealing time',
    }, AccountRecord: {
        Media: 'media platform',
        Status: 'Status',
        AccountEntity: 'Account opening entity',
        ApplyNumber: 'Application ID',
        PromotionLink: 'Promotion Link',
        StartTime: 'Start Time',
        EndTime: 'End Time',
        Reset: 'Reset',
        Search: 'Search',
        Export: 'Export',
        AccountApplicationID: 'Company name/Application ID',
        CreatedTime: 'Created Time',
        Operate: 'Operate',
        AccountInfo: 'Account Info',
        AccountID: 'Account ID',
        AccountName: 'Account Name',
        CompanyName: 'Company Name',
        Currency: 'Currency',
        AccountBalance: 'Account Balance',
        View: 'View',
        ViewAccount: 'View Account',
        Edit: 'Edit',
        Copy: 'Copy',
        RechargeTips: 'Tips: Setting up advertising plans with an unrecharged advertising account is likely to result in account closure. Please recharge your advertising account first. Thank you.',
        AddMonitoring: 'Add monitoring',
    }, AccountRecharge: {
        Add: 'Add Account',
        AccountName: 'Account Name',
        MediaPlatform: 'Platform',
        MonitoringAmount: 'Monitoring Amount',
        RechargeAmount: 'Recharge',
        CircuitTime: 'Circuit Time',
        State: 'State',
        Modify: 'Modify',
        Delete: 'Delete',
        Operate: 'Operate',
        IsDelete: 'Are you sure you want to delete it',
        SelectMediaPlatform: 'Please select a media platform',
        TransferAccount: 'Account',
        SelectTransferAccount: 'Please select the transfer account',
        MonitoringBalance: 'Monitoring',
        PutMonitoringBalance: 'Monitoring Balance',
        PutRechargeAmount: 'Please enter the recharge amount',
        MaximumTwoDecimal: 'Maximum two decimal places',
        IntervalTime: 'Time',
        PutIntervalTime: 'Please enter how many hours of rotation to patrol',
        Hours: 'Hour',
        Cancellation: 'Cancel',
        Submit: 'Submit',
        PleaseEnterInteger: 'Please enter an integer',
        SuccessfullyDeleted: 'Successfully deleted',
        accountStatus: 'Account Status',
        BudgetBalance: 'Budget balance',
        AdvertisingAccountBalance: 'Advertising account balance',
        MonitoringTime: 'Monitoring time (h)',
        StopDays: 'Stop days (days)',
        TourTime: 'Tour time',
        MonitoringStatus: 'Monitoring Status',
        Remark: 'Remark',
    }, AccountDetails: { //开户详情
        DocumentInformation: 'Document information',
        ApplicationID: 'Application ID',
        MediaPlatform: 'Media platform',
        CreationTime: 'Creation time',
        AccountInformation: 'Account information',
        AccountType: 'Account type',
        Industry: 'Industry',
        DeliveryCountry: 'Delivery country',
        AccountTimeZone: 'Account Time Zone',
        AccountAuthorization: 'Account Authorization',
        PromotionLink: 'Promotion link',
        Authorization: 'Authorization',
        Number: 'Number',
        EmailID: 'email / ID',
        Permission: 'Permission',
        EnterpriseInformation: 'Enterprise Information',
        CompanyName: 'Company Name',
        LicenseCode: 'License Code',
        License: 'License',
    }, CheckWallet: {
        WalletRechargeOrder: 'Wallet recharge order',
        AdvertisingTransactionOrders: 'Advertising transaction orders',
        AdvertisingConsumptionDetails: 'Advertising Consumption Details',
        WalletRecharge: 'Wallet recharge',
        RechargeAmount: 'Recharge amount',
        EnterRechargeAmount: 'Please enter the recharge amount',
        PaymentMethod: 'Payment method',
        SelectPaymentMethod: 'Please select payment method',
        Cancellation: 'Cancel',
        ConfirmRecharge: 'Confirm recharge',
        AdvertiserIdPlaceholder: "Please enter the advertising account ID",
        Reset: "Reset",
        Search: "Search",
        StaticA: "Statistics: Total expenses:",
        StaticB: "Total number of ad impressions:",
        StatTimeDay: "Date",
        AdvertiserId: "Advertising account name/Advertising account ID",
        Spend: "Spend",
        Impressions: "Impressions",
    }, CheckBalance: { // 钱包明细
        OrderNumber: 'Order number',
        ChangeType: 'Change type',
        OperationType: 'Operation type',
        Reset: 'Reset',
        Search: 'Search',
        PreChangeAmount: 'Pre change amount',
        ChangeAmount: 'Change amount',
        AmountAfterChange: 'Amount after change',
        Remarks: 'Remarks',
    }, CheckCredit: { // 信用卡明细
        OrderNumber: 'Order number',
        ChangeType: 'Change type',
        OperationType: 'Operation type',
        Reset: 'Reset',
        Search: 'Search',
        PreChangeAmount: 'Pre change amount',
        ChangeAmount: 'Change amount',
        AmountAfterChange: 'Amount after change',
        Remarks: 'Remarks',
        MainContent: 'Main Content'
    }, CheckAD: { // 广告交易订单
        AccountType: 'Account type',
        OrderNumber: 'Order number',
        AdvertisingName: 'Advertising Name',
        ActionType: 'Operation type',
        Status: 'Status',
        TransferStatus: 'Transfer status',
        Reset: 'Reset',
        Search: 'Search',
        PlatformType: 'Platform Type',
        Account: 'Account',
        TransferPlatform: 'Transfer advertising account platform',
        TransferPlatformId: 'Transfer advertising account name/Transfer advertising account ID',
        AccountId: 'Advertising account name/Advertising account ID',
        Remarks: 'Remarks',
        CreatedAt: 'Trading Hours',
    }, CheckPay: { // 钱包充值订单
        Sn: 'Order number',
        Status: 'Status',
        Reset: 'Reset',
        Search: 'Search',
        CurrencyName: 'Currency',
        PayTypeName: 'Payment method',
        Amount: 'Recharge amount',
        ExpiresAt: 'Order expiration time',
        PayTime: 'Payment Time',
        Operate: 'Operate',
        ImmediatePayment: 'Immediate payment',
    }, Settings: {
        Account: "Account Information",
        Company: "Company Information",
        EmailBind: "Email binding",
        PasswordUpdate: "Password modification",
        Avatar: "Avatar",
        Nickname: "User nickname",
        NicknamePlaceholder: "Please enter the user nickname",
        NicknameRule: "User nickname length only supports (3-20)",
        SubmitForm: 'Submit',
        Upload: "The image cannot exceed 10M",
        UpdateSuccess: "Modified successfully",
        EnterpriseName: "Enterprise Name",
        EnterpriseEmail: "Enterprise email",
        EnterprisePhone: "Enterprise Phone",
        EnterpriseAddress: "Enterprise address",
        EnterpriseNamePlaceholder: "Please enter the company name",
        EnterpriseEmailPlaceholder: "Please enter your company email address",
        EnterprisePhonePlaceholder: "Please enter the contact phone number",
        EnterpriseAddressPlaceholder: "Please enter the company address",
        Email: "Mailbox",
        OldEmailCode: "Email verification code",
        OldEmailCodePlaceholder: "Please enter the binding email verification code",
        SendSms: "Send verification code",
        BindEmail: "Bind email",
        BindEmailPlaceholder: "Please enter the bound email address",
        BindEmailCode: "Bind email verification code",
        BindEmailCodePlaceholder: "Please enter the email verification code",
        SendCodeSuccess: "Successfully sent verification code",
        EmailBindSuccess: "Email binding successful",
        EmailBindCodePlaceholder: "Please enter the email verification code",
        EmailSuccess: "Please enter the correct email address",
        OldPassword: "Old password",
        OldPasswordPlaceholder: "Please enter your old password",
        Password: "Password",
        PasswordPlaceholder: "Please enter a new password",
        RePassword: "Confirm password",
        RePasswordPlaceholder: "Please enter a confirmation password",
        PasswordUpdateSuccess: "Password modification successful",
        UserAccount: "User Account",
        ChangePhoneNumber: "Change phone number",
    }
    , Help: {
        ReleaseTime: "Release time",
        Title: "title",

    }, Other: {
        TikTokPlatform: "TikTok platform-account application",
        NewQualification: "New qualification",
        VerifiedQualifications: "Verified qualification",
        SelectVerifiedQualification: "Select verified qualification certificate for reuse",
        AutomaticallyReview: "Advertising accounts created with verified qualification certificates will automatically pass the review",
        SelectVerifiedQualifications: "Please select verified qualification",
        AdvertisingAccounts: "Advertising accounts",
        AdvertisingArea: "Advertising area",
        PleaseSelectAdvertising: "Please select advertising area",
        NumberApp: "Application quantity",
        PleaseNumberApp: "Please enter the application quantity",
        LegalPerson: "Legal person's name",
        PleaseLegalPerson: "Please enter the legal person's name",
        IDNumber: "Legal person's ID card",
        PleaseIDNumber: "Please enter the legal person's ID card",
        BankAccountNumber: "Legal person's bank account number",
        PleaseBankAccountNumber: "Please enter the legal person's bank account number",
        BankMobileNumber: "Legal person's mobile phone",
        PleaseBankMobileNumber: "Please enter the legal person's mobile phone",
        AccountSelection: "Account selection",
        FormEntry: "Form entry",
        BulkAdvertisingAccounts: "You can directly copy the advertising account ID from Excel, separated by spaces in sequence, as shown below",
        BatchSearch: "Batch search",
        ConfirmSub: "Confirm submission",
        AddRunningAccount: "Add running account",
        MonitorStatus: "Monitoring status",
        Balance: "Balance",
        ConfirmStop: "Confirm stop",
        RunAccountList: "Running account list",
        SearchRunAccount: "Search running account",
        BatchClose: "Batch closing operation",
        RemainingTimes: "Number of remaining transfers today",
        UKTimeZone: "Note: Please note that a single account can only transfer 10 times per day, and the operation time is based on the UK time zone~",
        PleaseEnterBalance: "Please enter the balance",
        PleaseBudgetBalance: 'Please enter the budget balance',
        EditorialMonitor: 'Edit monitoring',
        AdvertiseAccountID: 'Advertisement account ID',
        ConfirmAdd: 'Confirm to add',
        SearchAddAccount: 'Search to add account',
        AddEnableAccounts: 'Batch add open accounts',
        OpenAccountList: 'Open account list',
        BatchOperations: 'Batch operations',
        Phone: 'Mobile phone number',
        ReleaseArea: 'Release area',
        WeChatBind: 'WeChat binding',
        Bind: 'Bind',
        UnBind: 'Unbind',
        SubCustomerAlias: 'Sub-customer alias',
        SubCustomers: 'Sub-customers',
        PleaseSubCustomerAlias: 'Please sub customer alias',
        AccountBalance: 'Account Balance',
        KwaiPlatform: "Kwai Platform - Account Opening Application",
        BusinessScope: "Business Scope",
        BusinessLicense: "Business Scope. Please match your business license",
        AdType: "Ad Account Type",
        EffectAdAccount: "Performance Ad Account",
        Industry: "Industry of Content",
        SeleteIndustry: "Please select industry of content",
        ProductBrandName: "Product or Brand Name",
        PleaseProductBrandName: "Please enter product or brand name",
        PleaseRregisAddress: "Please enter company registered address",
        RregisAddress: "Company registered address",
        CheckEmail: "Check Email",
        BindEmail: "Binded Email",
        UnbindEmail: "Unbinded Email",
        BindUnbindEmail: "Binded/Unbinded Email",
        SerialNumber: "Number",
        BindStatus: "Binding Status",
        GooglePlatform: "Google Platform Account Opening Application"
    }, Omissions: {
        OnlineRecharge: 'Online recharge',
        ActualAmount: 'Actual amount',
        SelectRechargeMethod: 'Select recharge method',
        OnlinePay: 'Online payment',
        OfflineTransfer: 'Offline transfer',
        Recommend: 'Recommend',
        OnlinePayMethods: 'Choose online payment method for RMB recharge, support use',
        USDPayoptions: 'Choose offline transfer for USD recharge, support use',
        RemainingBalance: 'Remaining balance',
        Increase: 'Increase',
        Decrease: 'Decrease',
        ExchangeRate: 'Exchange rate',
        HandlingFees: 'Handling Fees',
        TransactionDetails: 'Transaction details',
        TransactionID: 'Transaction ID',
        TransactionVoucher: 'Transaction voucher',
        Remark: 'Remark',
        DeductedBalance: 'Actual deduction balance',
        MonitoringOn: 'Monitoring on',
        MonitoringOff: 'Monitoring off',
        MasterAccount: 'Master account',
        SubAccount: 'Subaccount',
        Username: 'Username',
        AdvertiserNum: 'Number of advertising accounts',
        CreditBalance: 'Credit balance',
        LastLoginTime: 'Last login time',
        BalanceAllocation: 'Balance allocation',
        AccountAllocation: 'Account allocation',
        ResetPassword: 'Reset password',
        UserDetail: 'Account details',
        NewAccount: 'Create a new account',
        LogRecording: 'Log record',
        AddSubUser: 'Add a sub account',
        PleaseName: 'Please enter a name (no more than five fields)',
        LoginPassword: 'Please enter a 6-20-digit login password (including uppercase and lowercase letters)',
        ConfigPleasePassword: 'Please enter your password again',
        username: 'Username',
        pleasePassword: 'Confirm password',
        AdjustmentType: 'Adjustment type',
        Confirm: 'Confirm',
        AssignedAdvertAccounts: 'Assigned advertising accounts',
        AddSubUserDetail: 'Sub-account details',
        AllocatedAmount: 'Allocated amount',
        AdvertiserName: 'Account name',
        AdvertiserID: 'Account ID',
        ConsumedBalance: 'Consumed balance',
        SystemInfo: 'System information',
        CurrentWalletBalance: 'Current wallet balance',
        CurrentCreditBalance: 'Current credit balance',
        AdjustmentAmount: 'Adjustment amount',
        PleaseAdjustmentAmount: 'Please enter the adjustment amount',
        PleaseSelectType: 'Please select type',
        MasterAccountBalance: 'Master account balance',
        MasterAccountCreditBalance: 'Master account credit balance',
        AccountRecycle: 'Account Recycle',
        AccountRecycleList: 'Account Recycle List',
    },
    SubClient: {
        OnlineRecharge: 'Online Recharge',
        ProxyLinks: 'Proxy Links',
        SubManagement: 'Sub-client Management',
        RiskControlStatus: 'Risk Control Status',
        Normal: 'Normal',
        Disable: 'Disable',
        Username: 'User Name',
        Mail: 'Email',
        WalletBalance: 'Wallet Balance',
        AccountBalance: 'Credit Balance',
        AdvertiserNumber: 'Number of Advertising Accounts',
        Phone: 'Phone Number',
        BalanceRecharge: 'Balance Reduction',
        BalanceReduction: 'Balance Reduction',
        BasicInformation: 'Basic Information',
        UserUpdate: 'User Name Change',
        LinkAccounts: 'Linked Accounts',
        TransactionRecords: 'Transaction Records',
        OpenRecords: 'Account Opening Records',
        UserId: 'User ID',
        ReductionChannels: 'Reduction Channels',
        MyBalance: 'My Balance',
        SubClientBalance: 'Sub-client balance',
        AmountReduction: 'Reduction amount',
        PleaseAmountReduction: 'Please enter the reduction amount',
        BalanceAfterDeduction: 'Balance after reduction',
        Remark: 'Remark',
        PleaseRemark: 'Please enter the remark',
        Recharge: 'Recharge',
        RechargeChannels: 'Recharge channels',
        RechargeAmount: 'Recharge amount',
        PleaseRechargeAmount: 'Please enter the recharge amount',
        BalanceAfterRecharge: 'Balance after recharge',
        EditName: 'Edit name',
        ChangeName: 'Change name',
        SubClientname: 'Sub-client name',
        AdvertiserNum: 'Number of advertisements',
        LoginRest: 'Login limit',
        OpenRest: 'Account opening limit',
        AccountClosureRate: 'Account closure rate',
        LastLoginIP: 'Last login IP',
        LastLoginTime: 'Last login time',
        Reduction: 'Reduction',
        Operator: 'Operator',
        TransactionAmount: 'Transaction Amount',
        CreditBalanceRecord: 'Credit Balance Details',

    },
    Notice: {
        BatchRead: 'Batch read',
        MessageStatus: 'Message status',
        Title: 'title',
        Summary: 'summary',
        ReleaseTime: 'Release time',
        MessageType: 'Message type',
        Operate: 'Operate',
        QueryDetails: 'Query Details',
        Details: 'Details',
        PleaseEnterMessageTitle: 'Please enter message title',
        All: 'All',
        Read: 'Read',
        Unread: 'Unread',
        SystemNotice: 'SystemNotice',
        OrdinaryNotice: 'OrdinaryNotice',
    },
    Zero: {
        ConfirmBatchZero: 'Confirm Batch Zeroing',
        Reminder: 'Zeroing Reminder',
        Prompt1: '1. The final amount transferred out is subject to the actual amount on the platform',
        Prompt2: '2. The final zeroed amount is subject to the actual amount on the platform. The actual zeroed amount can be viewed in the amount change record of the bill management. The processing time is 1-3 business days',
        Prompt3: '3. Currently, zeroing only supports closed advertising accounts',
    },
    Partner: {
        marketingToolintro: "TIKTOK is a brand new product",
        crossBorderBrowserintro: 'This page has been opened.',
        storeOperationToolsintro: 'TIKTOK has been updated in 2018.',
        USCloudPhoneintro: 'Ushop Chinese food and beverages ERP',
        TermsService: "In the future, Adseasy will open a new window, If you want to be a part of the family",
        serviceRecommendation: 'service recommendation',
        marketingToolDetail: "We will show you the best of the best in the world. If you create an AI-powered document, you will see an AI-powered image. If you want to be a part of the world, you will find the world's most beautiful things. ，达秘一键触达、附带达人管理系统，邀约管理流程SOP化。",
        crossBorderBrowserDetail: 'We will show you the best of the best in the world. This article will show you how to create a new image',
        storeOperationToolsDetail: "If you want AI to be a part of the world, then you'll be able to see what's going on in TikTok. zada、Shopee、Shein等多家电商平台本土及跨境店铺。",
        USCloudPhoneDetail: "Shopping online: Shopping, Shopee, PayPal, TikTok, etc. ；If you don't want to leave the house, then you will leave the house alone.",
    },
    MonthSettlement: {
        list: 'Monthly Settlement List',
        enterpriseName: 'Company Name',
        monthBill: 'Bill Month',
        money: 'Current Bill Amount',
        file: 'Download',
        createdAt: 'Generation Time',
        remark: 'Remarks',

    }
}